import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Codepen = function Codepen(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12 9-7.9361 5.1584c-.6879.4471-1.0318.6707-1.151.9542a1 1 0 0 0 0 .7747M12 8.9999l7.9361 5.1585c.6879.4471 1.0318.6707 1.1509.9542a1 1 0 0 1 0 .7747M12 8.9999V2.5M12 15 4.0639 9.8415c-.6879-.4472-1.0318-.6707-1.151-.9542a1 1 0 0 1 0-.7747M12 14.9999l7.9361-5.1584c.6879-.4472 1.0318-.6707 1.1509-.9542a1 1 0 0 0 0-.7747M12 14.9999v6.5m9.272-5.5267-8.4 5.46c-.3156.2051-.4735.3077-.6435.3476a1 1 0 0 1-.457 0c-.17-.0399-.3279-.1425-.6435-.3476l-8.4-5.46c-.266-.173-.399-.2594-.4954-.3747a1 1 0 0 1-.1884-.3473C2 15.1075 2 14.9489 2 14.6316V9.3682c0-.3172 0-.4758.0442-.6195a1 1 0 0 1 .1885-.3473c.0963-.1153.2293-.2018.4953-.3747l8.4-5.46c.3156-.2051.4735-.3077.6435-.3476a1 1 0 0 1 .457 0c.17.0399.3279.1425.6435.3476l8.4 5.46c.266.173.399.2594.4954.3747a1 1 0 0 1 .1884.3473C22 8.8924 22 9.051 22 9.3682v5.2634c0 .3173 0 .4759-.0442.6196a1 1 0 0 1-.1884.3473c-.0964.1153-.2294.2017-.4954.3747"
    })
  }));
};
export default Codepen;